// @flow
import { connect } from 'react-redux';

import DomainInput from '../../components/DomainInput';
import type { FullState } from '../../types';
import { validateSearch as submitSearch } from '../modules/actions';
import { selectSearchLoading, selectSearchValue } from '../modules/selectors';

const mapStateToProps = (state: FullState) => ({
  value: selectSearchValue(state),
  loading: selectSearchLoading(state),
});

const mapDispatchToProps = {
  submitSearch,
};

// $FlowFixMe[underconstrained-implicit-instantiation]
export default (connect(
  mapStateToProps,
  mapDispatchToProps,
  // $FlowFixMe[cannot-resolve-name]
)(DomainInput): Class<ConnectedComponent<mixed, any>> & any);
